import template from './ceiling-height.jade';

export default angular
    .module('cian.addForm.aboutObjectCeilingHeight', ['cian.addForm.ceilingHeight'])
    .directive('cianAfAboutObjectCeilingHeight', () => ({
        scope: {},
        bindToController: {
            ad: '=',
            form: '=',
        },
        controller: [function () {}],
        controllerAs: 'ceilingHeight',
        template,
    }))
    .name;
